<template>
  <div>
    <form method="post" @submit.prevent="doUpdate">
      <div class="form-group">
          <div class="col-xs-12 text-center">
              <div class="user-thumb text-center">
                <img alt="thumbnail" class="img-circle" width="100" :src="item.user.profileImg.replace('square', 'large')">
              </div>
          </div>
      </div>
      <alert-box type="success" class="text-center card-subtitle">
        Please set your password before continue.
      </alert-box>
      <input-text
        type="text"
        name="email"
        :value="item.user.email"
        label="Email"
        disabled="disabled"
      />
      <input-text
        type="password"
        name="password"
        :value="form.password"
        label="Password"
        @input="text => { setField({ key: 'password', value: text }) }"
      />
      <input-text
        type="password"
        name="passwordRepeat"
        :value="form.passwordRepeat"
        label="Repeat Password"
        @input="text => { setField({ key: 'passwordRepeat', value: text }) }"
      >
        <div class="text-danger" v-if="formValidation && formValidation.error">
          <small>{{formValidation.error}}</small>
        </div>
      </input-text>
      <div class="form-footer">
        <form-button
          type="info"
          inputType="submit"
          text="UPDATE"
          :loading="loading"
          :block="true"
          :click="() => {}"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import InputText from '@/components/Form/InputText';
import FormButton from '@/components/Form/FormButton';
import AlertBox from '@/components/Misc/AlertBox';

export default {
  name: 'LoginForm',
  components: {
    InputText,
    FormButton,
    AlertBox,
  },
  data: () => {
    return {
      formValidation: {}
    };
  },
  computed: {
    ...mapGetters({
      item: "auth/item",
      form: "auth/form",
      loading: 'auth/loading',
      updatePasswordDone: 'auth/updatePasswordDone'
    })
  },
  methods: {
    ...mapActions({
      login: 'auth/login',
      ssoLogin: 'auth/ssoLogin',
      setField: 'auth/setField',
      updateUserPassword: 'auth/updateUserPassword',
      refreshToken: 'auth/refreshToken'
    }),
    async doUpdate() {
      const { password, passwordRepeat } = this.form;
      this.formValidation = {
        error: password !== passwordRepeat ? 'Repeat password not same!' : ''
      };
      if (!this.formValidation.error) {
        await this.updateUserPassword({ newPassword: password, id: this.item.user.id });
        await this.refreshToken();
        this.$router.push({ name: 'index' });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.or-item {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  top: -10px;
  background: white;
  width: 45px;
}

.login-btn {
  text-transform: uppercase;
}

.login-btn .fa {
  font-size: 1.5rem;
}
.img-circle {
  border-radius: 100%;
}
</style>
